
import { computed, defineComponent, PropType } from 'vue';
import {
  Colour,
  getForegroundColourFromBackground,
} from '../../../helpers/colour';
import TpxAccordion from '../../molecules/accordion/accordion.vue';
import './accordion-group.scss';

/**
 * TPX accordion group
 *
 * @example
 * <code>import TpxAccordionGroup from '@manifesto-tech/tpximpact-design-system/components/molecules/accordion-group/accordion-group.vue'</code>
 */
export default defineComponent({
  name: 'TpxAccordionGroup',
  components: {
    TpxAccordion,
  },

  props: {
    /**
     * Background colour of the accordions
     */
    backgroundColour: {
      default: Colour.White,
      type: String,
      validator: (value: Colour) => {
        return Object.values(Colour).includes(value);
      },
    },

    /**
     * Array of accordions
     */
    accordions: {
      type: Array as PropType<Array<typeof TpxAccordion>>,
      required: true,
    },
  },


  setup(props) {
    return {
      colourClasses: computed(() => ({
        [`bg--${props.backgroundColour}`]: !!props.backgroundColour,
        [`text--${getForegroundColourFromBackground(props.backgroundColour)}`]:
          !!props.backgroundColour,
      })),
    };
  },

  mounted() {
    //if inside a hideAndSeekBlock, open the first accordion row
    const thisAccordionRow = this.$refs['accordionGroup'] as HTMLElement;
    const thisAccordionGroupIsInAHideAndSeekBlock = thisAccordionRow.closest(`[data-component="hideAndSeekBlock"]`) != null;
    if (thisAccordionGroupIsInAHideAndSeekBlock) { this.$refs.accordionItems[0].toggle(); }
  },

  methods: {
    closeAllNonClickedAccordions(clickedAccordion) {
      this.$refs.accordionItems.forEach((accordion) => {
        const thisAccordionWasNotClicked = (clickedAccordion.heading != accordion.heading) || (clickedAccordion.text != accordion.text);
        if (thisAccordionWasNotClicked) { accordion.close() }
      });
    },
  }


});
